import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  const mqTablet = window.matchMedia('(min-width: 768px)');
  const mqDesktop = window.matchMedia('(min-width: 1024px)');

  function hideShowPagination(slider) {
    const slides = slider.el.querySelectorAll('.card-carousel .wp-block-deepsea-column').length;
    const controls = slider.el.querySelector('.card-carousel-controls');
    if (mqDesktop.matches) {
      if (slides < 4) {
        controls.style.display = 'none';
      } else {
        controls.style.display = 'flex';
      }
    } else if (mqTablet.matches) {
      if (slides < 3) {
        controls.style.display = 'none';
      } else {
        controls.style.display = 'flex';
      }
    } else if (slides < 2) {
      controls.style.display = 'none';
    } else {
      controls.style.display = 'flex';
    }
  }

  const elementsExist = document.querySelectorAll('.card-carousel');

  if (elementsExist.length > 0) {
    const isDesktop = window.matchMedia('(min-width: 1240px)');

    // eslint-disable-next-line array-callback-return
    Array.from(elementsExist).forEach((el) => {
      const item = el.querySelector('.wp-block-deepsea-column');
      const isHomePageFs = el.parentElement.classList.contains('home-page-fs-carousel');
      const isFounderStoryHero = el.parentElement.previousElementSibling?.classList.contains(
        'founder-story-hero--desktop',
      );
      let firstSlide;

      // eslint-disable-next-line no-unused-vars
      const newSwiper = new Swiper(el, {
        slidesPerGroup: 1,
        threshold: 1,
        spaceBetween: 20,
        slidesPerView: 1,
        setWrapperSize: true,
        observer: typeof item !== 'undefined' && item != null,
        observeParents: typeof item !== 'undefined' && item != null,
        wrapperClass: 'wp-block-deepsea-columns',
        slideClass: 'wp-block-deepsea-column',
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        breakpoints: {
          699: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
          1239: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 24,
          },
          1939: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: item?.classList.contains('founder-story') ? 24 : 32,
          },
        },
        on: {
          init() {
            firstSlide = this.el.querySelector('.wp-block-deepsea-column:first-child');
            firstSlide?.classList.add('swiper-slide-first');
            if (isDesktop.matches && (isHomePageFs || isFounderStoryHero)) {
              firstSlide.remove();
            }

            hideShowPagination(this);

            setTimeout(() => {
              this.update();
            }, 500);
          },
          resize() {
            if (isHomePageFs || isFounderStoryHero) {
              if (!isDesktop.matches && this.el.querySelector('.swiper-slide-first') === null) {
                this.prependSlide(firstSlide);
              } else if (
                isDesktop.matches &&
                this.el.querySelector('.swiper-slide-first') !== null
              ) {
                firstSlide.remove();
              }
            }

            hideShowPagination(this);

            setTimeout(() => {
              this.update();
            }, 500);
          },
        },
      });
    });
  }

  const elementsExistNew = document.querySelectorAll('.card-carousel-new');
  if (elementsExistNew.length > 0) {
    // eslint-disable-next-line array-callback-return
    Array.from(elementsExistNew).forEach((el) => {
      const item = el.querySelector('.wp-block-deepsea-column');
      // eslint-disable-next-line no-unused-vars
      const newSwiper = new Swiper(el, {
        slidesPerGroup: 1,
        threshold: 1,
        spaceBetween: 20,
        slidesPerView: 1,
        setWrapperSize: true,
        observer: typeof item !== 'undefined' && item != null,
        observeParents: typeof item !== 'undefined' && item != null,
        wrapperClass: 'wp-block-deepsea-columns',
        slideClass: 'wp-block-deepsea-column',
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        breakpoints: {
          699: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
          1239: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 24,
          },
        },
      });
    });
  }
});
